module.exports = __webpack_public_path__ + "img/16_122.f664a6e6.png";